import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { CompanyModel } from '../../../../model/company.model';
import { CoreApiService } from '../../../../core/service/core-api-service';
import { properties } from '../../../../../environments/properties';
import { JsonRequest } from '../../../../model/jsonRequest.model';
import { TooltipModule } from 'primeng/tooltip';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DialogModule } from 'primeng/dialog';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { AppService } from '../../../../core/service/app.service';

@Component({
  selector: 'app-list-company',
  standalone: true,
  imports: [
    ButtonModule,
    TableModule,
    TooltipModule,
    InputSwitchModule,
    FormsModule,
    DialogModule,
    FileUploadModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
  ],
  templateUrl: './list-company.component.html',
  styleUrl: './list-company.component.css',
})
export class ListCompanyComponent implements OnInit {
  ltsCompany!: CompanyModel[];
  companySelected!: CompanyModel;
  dialogCompany: boolean = false;
  isCreate: boolean = false;
  tituloDialog: string = '';
  uploadedFiles: any[] = [];
  uploadedFile!: any;
  loading: boolean = false;
  formCompany = new FormGroup({
    com_name: new FormControl('', Validators.required),
    com_phone: new FormControl('', Validators.required),
    com_address: new FormControl('', Validators.required),
  });

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
  ) {}

  ngOnInit(): void {
    this.getListCompany();
  }

  getListCompany(): void {
    const body: JsonRequest = {
      data: '',
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.loading = true;
    this.apiService.consumirWSPost(
      properties.serviceGetAllCompany,
      body,
      (data) => {
        this.ltsCompany = data.data;
        this.ltsCompany.forEach((item) => {
          item.estado = item.com_status == 1;
        });
        this.loading = false;
      },
    );
  }
  cambiarEstado(e: any) {
    console.log(e);
  }

  openDialog(isCreate: boolean, companySelected: any): void {
    this.dialogCompany = true;
    this.isCreate = isCreate;
    if (isCreate) {
      this.tituloDialog = 'Crear Compañia';
      this.formCompany.reset();
    } else {
      this.tituloDialog = 'Editar Compañia';
      this.companySelected = companySelected;
      this.formCompany.patchValue(this.companySelected);
    }
  }

  onSelectImage(event: any) {
    this.uploadedFile = event[0];
  }

  removeFile(): void {
    this.uploadedFiles = [];
    this.uploadedFile = null;
  }

  cancel(): void {
    this.formCompany.reset();
    this.removeFile();
    this.dialogCompany = false;
  }
  saveCompany(): void {
    const fd = new FormData();

    if (this.isCreate) {
      fd.append(
        'datos',
        JSON.stringify({
          com_name: this.formCompany.get('com_name')?.value,
          com_phone: this.formCompany.get('com_phone')?.value,
          com_address: this.formCompany.get('com_address')?.value,
          com_logo: '',
        }),
      );
    } else {
      fd.append(
        'datos',
        JSON.stringify({
          com_name: this.formCompany.get('com_name')?.value,
          com_phone: this.formCompany.get('com_phone')?.value,
          com_address: this.formCompany.get('com_address')?.value,
          com_status: 1,
          com_id: this.companySelected.com_id,
        }),
      );
    }

    fd.append('files', this.uploadedFile);
    fd.append('fecha', new Date().toUTCString());
    fd.append('company', this.util.returnEmpresa().toString());

    this.apiService.consumirWSFilePost(
      this.isCreate == true
        ? properties.serviceCreateCompany
        : properties.serviceUpdateCompany,
      fd,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.formCompany.reset();
          this.removeFile();
          this.dialogCompany = false;
          this.getListCompany();
          this.util.mostrarToast(
            'Crear Compañia',
            'Se ha creado la compañia',
            1,
          );
        } else {
          this.util.mostrarToast('Crear Compañia', 'Error al crear', 4);
        }
      },
    );
  }
}
